import React from 'react';
import { Container, Box, Typography, Link, Button } from '@mui/material';
// ...existing imports...

export default function AffliatesPage() {
  const fxProTrackingUrl = 'https://fxproaffiliate.g2afse.com/click?pid=5755&offer_id=81';
  const imagePath = '/affliate_images/320x480_market-moves-1_eng_mu_android.png';
  const xmTrackingUrl = 'https://clicks.pipaffiliates.com/c?m=132346&c=1104194';
  const xmImageUrl = 'https://ads.pipaffiliates.com/i/132346?c=1104194';

  const handleLinkClick = (url) => (e) => {
    e.preventDefault();
    try {
      const opened = window.open(url, '_blank');
      if (!opened) {
        // Popup blocked - navigate same tab
        window.location.href = url;
      }
    } catch (err) {
      // If any error, fallback to same-tab navigation
      window.location.href = url;
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>Affliates</Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Ready to start trading for real?
          <br />
          Support the project by using the affiliate link below.
          <br />
          But please trade responsibly. Success with this pattern tool does not guarantee success in real trading.
        </Typography>
        
        {/* FXPro Affiliate */}
        <Link
          href={fxProTrackingUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick(fxProTrackingUrl)}
          sx={{ display: 'inline-block', mb: 2 }}
        >
          <img src={imagePath} alt="FXPro Affiliate" style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }} />
        </Link>

        {/* XM Affiliate */}
        <Link
          href={xmTrackingUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick(xmTrackingUrl)}
          sx={{ display: 'inline-block' }}
        >
          <img src={xmImageUrl} alt="XM Affiliate" style={{ maxWidth: '100%', height: 'auto', borderRadius: 8 }} referrerPolicy="no-referrer-when-downgrade" />
        </Link>
      </Box>
    </Container>
  );
}
// Diagnostic component removed
